import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import 'animate.css'
import App from './App.js'
import reportWebVitals from './reportWebVitals.js'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <App />
)
reportWebVitals()
